const home = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
}

export default home
